module.exports = __webpack_public_path__ + "granuli_pp@2x.jpg?d58ee31f881fbbc54c469c0cd657afae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/granuli_pp@2x.jpg
// module id = 197
// module chunks = 0